<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@signIn" >Sign In</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>
@if (invalidCridentials) {
  <div class="error invalid-cridentials d-flex justify-content-center align-items-center">
    <mat-icon class="mr-8" i18n-aria-label aria-label="Error">error</mat-icon>
    <span i18n="@@invalidCridentials">The user name or password you entered is incorrect! Please try again.</span>
  </div>
}

<mat-dialog-content>
  <form [formGroup]="loginForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label i18n="@@emailLabel">Email</mat-label>
      <input data-testid="signin_email" matInput id="email" placeholder="Email" i18n-placeholder="@@emailPlaceholder" name="email" formControlName="email" required />
      <mat-error>
        @if (loginForm.get('email')?.hasError('required') && loginForm.get('email')?.touched) {
          <span i18n="@@inValidRequiredField">This field is required</span>
        }
        @if (loginForm.get('email')?.hasError('email') && loginForm.get('email')?.touched) {
          <span i18n="@@inValidEmail">Please enter a valid email</span>
        }
      </mat-error>
    </mat-form-field>

    <mat-form-field class="w-100" appearance="outline">
      <mat-label i18n="@@passwordLabel">Password</mat-label>
      <input data-testid="signin_password" matInput id="password" i18n-placeholder="@@passwordPlaceholder" placeholder="Password" name="password" type="password" formControlName="password" required />
      <mat-error>
        @if (loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched) {
          <span i18n="@@inValidRequiredField">This field is required</span>
        }
      </mat-error>
    </mat-form-field>

    @if (maximumAllowedAttempts) {
      <div i18n="@@maxAttepmts" class="error text-center">Maximum allowed attempts reached</div>
    }
    <div class="text-center forget-password-link mat-caption">
      <a class="cursor" i18n="@@forgetYourPassword" data-testid="forget_password_link"  (click)="openForgetPassword()">Forgot your password?</a>
    </div>

    <mat-dialog-actions>
      <button i18n="@@signIn" class="w-100" mat-raised-button color="primary" data-testid="signin_button" (click)="onSubmit()">Sign In</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>